import React from 'react';

interface SidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeSection, onSectionChange, onLogout }) => {
  const sections = [
    { id: 'overview', title: 'Overview', icon: '📊' },
    { id: 'beta-management', title: 'Beta Management', icon: '👥' },
    { id: 'messages', title: 'Emails', icon: '📧' },
    { id: 'testflight', title: 'TestFlight', icon: '🚀' },
    { id: 'testflight-testers', title: 'TestFlight Testers', icon: '👥' },
    { id: 'appstore', title: 'App Store Stats', icon: '🏪' },
    { id: 'version', title: 'Version Control', icon: '📱' }
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-title">
          <span>🎭</span>
          ControllerApp
        </div>
        <div className="sidebar-subtitle">Admin Dashboard</div>
      </div>
      
      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-section-title">Main</div>
          {sections.slice(0, 1).map(section => (
            <div
              key={section.id}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => onSectionChange(section.id)}
            >
              <span className="nav-icon">{section.icon}</span>
              {section.title}
            </div>
          ))}
        </div>
        
        <div className="nav-section">
          <div className="nav-section-title">Beta Management</div>
          {sections.slice(1, 2).map(section => (
            <div
              key={section.id}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => onSectionChange(section.id)}
            >
              <span className="nav-icon">{section.icon}</span>
              {section.title}
            </div>
          ))}
        </div>
        
        <div className="nav-section">
          <div className="nav-section-title">App Management</div>
          {sections.slice(2).map(section => (
            <div
              key={section.id}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => onSectionChange(section.id)}
            >
              <span className="nav-icon">{section.icon}</span>
              {section.title}
            </div>
          ))}
        </div>
      </nav>
      
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>
          <span>🚪</span>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
